/**
 * The fixed list of roles a guest can hold at an event. The values are the
 * API's own (stored as-is); labels are what people read. A role is separate
 * from the honoree flag: a role does not make a guest an honoree, and an
 * honoree needs no role.
 */
export const GUEST_ROLE_VALUES = [
  'bride',
  'groom',
  'maid_of_honour',
  'best_man',
  'bridesmaid',
  'groomsman',
  'parent_of_bride',
  'parent_of_groom',
  'officiant',
  'mc',
  'usher',
  'celebrant',
  'other',
] as const;

export type GuestRole = (typeof GUEST_ROLE_VALUES)[number];

export const GUEST_ROLE_LABELS: Record<GuestRole, string> = {
  bride: 'Bride',
  groom: 'Groom',
  maid_of_honour: 'Maid of honour',
  best_man: 'Best man',
  bridesmaid: 'Bridesmaid',
  groomsman: 'Groomsman',
  parent_of_bride: 'Parent of the bride',
  parent_of_groom: 'Parent of the groom',
  officiant: 'Officiant',
  mc: 'MC',
  usher: 'Usher',
  celebrant: 'Celebrant',
  other: 'Other',
};

/** Dropdown options: "None" first, then every role. */
export const GUEST_ROLE_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: '', label: 'None' },
  ...GUEST_ROLE_VALUES.map(value => ({ value, label: GUEST_ROLE_LABELS[value] })),
];

/** Readable label for a stored role value; unknown values are shown as received. */
export function guestRoleLabel(role: string | null | undefined): string {
  if (!role) return '';
  return (GUEST_ROLE_LABELS as Record<string, string>)[role] ?? role;
}
